import React, { useState } from "react";
import OurClientContext from "./OurClientContext";
import { randomStr } from "../../../utils/helper";

const OurClientState = (props) => {
  const [apiData, setApiData] = useState({ data: [], isLoading: false });
  const [apiDataOurTeam, setApiDataOurTeam] = useState({
    isLoading: false,
    data: [],
  });
  const [theme, setTheme] = useState("");
  const [backImageToggle, setBackImageToggle] = useState(false);
  const [skill, setSkill] = useState([
    { id: randomStr(2), skill: "", parentageOfSkill: "" },
  ]);
  const [imageIs, setImageIs] = useState("");
  const [isBackgroundColor, setIsBackgroundColor] = useState(false);
  const [collId, setCollId] = useState();
  const [fromData, setFormData] = useState({
    title: "",
    subTitle: "",
    navMapId: "",
    webId: localStorage.getItem("webId"),
    theme: 1,
    isTitleShow: true,
    itemLimit: "",
    style: {
      ".clients-section": {
        padding: "100px 0",
        "background-color": "rgb(255 255 255 / 100)",
      },
      ".clients-section.bg-image": {
        "background-image": "",
      },
      ".clients-section.bg-image::before": {
        "background-color": "",
        // rgb(0 0 0 / 0.8)
      },
      ".clients-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        "background-color": "rgb(255 73 124 / 0.2)",
        padding: "5px 20px",
        p1: "5px",
        p2: "20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
      },
      ".clients-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: "rgb(0 0 0 / 100)",
        "margin-bottom": "10px",
      },
      ".clients-slider .slick-arrow:before": {
        color: "rgb(255 73 124 / 100)",
      },
      ".clients-slider .client-img": {
        padding: "10px",
        "max-width": "300px",
        "max-height": "120px",
      },
    },
  });

  const [formDataChild, setFormDataChild] = useState({
    title: "",
    subTitle: "",
    image: "",
    isTitleShow: true,
    order: 1,
    webId: localStorage.getItem("webId"),
    navMapId: "",
  });

  const [settingFormData, setSettingFormData] = useState({
    ".clients-section": {
      padding: "100px 0",
      "background-color": "rgb(255 255 255 / 100)",
    },
    ".clients-section.bg-image": {
      "background-image": "",
    },
    ".clients-section.bg-image::before": {
      "background-color": "",
      // rgb(0 0 0 / 0.8)
    },
    ".clients-section .section-title-area .section-subtitle": {
      "font-size": "16px",
      "font-weight": "600",
      color: "rgb(255 73 124 / 100)",
      "background-color": "rgb(255 73 124 / 0.2)",
      padding: "5px 20px",
      p1: "5px",
      p2: "20px",
      "border-radius": "15px",
      "margin-bottom": "15px",
    },
    ".clients-section .section-title-area .section-title": {
      "font-size": "44px",
      "font-weight": "600",
      color: "rgb(0 0 0 / 100)",
      "margin-bottom": "10px",
    },
    ".clients-slider .slick-arrow:before": {
      color: "rgb(255 73 124 / 100)",
    },
    ".clients-slider .client-img": {
      padding: "10px",
      "max-width": "300px",
      "max-height": "120px",
    },
    image: "",
    ourClientId: "",
  });
  const [boxSection, setBoxSection] = useState(false);
  const [id, setId] = useState("");
  const [childId, setChildId] = useState("");
  const [navMapId, setNavMapId] = useState("");
  const [galleryImgId, setGalleryImgId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isParent, setIsParent] = useState(false);
  const [filter, setFilter] = useState("");
  const [imgShow, setImgShow] = useState(false);
  const [sectionPageName, setSectionPageName] = useState("");
  return (
    <OurClientContext.Provider
      value={{
        apiData,
        setApiData,
        apiDataOurTeam,
        setApiDataOurTeam,
        fromData,
        setFormData,
        id,
        setId,
        isEdit,
        setIsEdit,
        filter,
        setFilter,
        skill,
        galleryImgId,
        setGalleryImgId,
        setSkill,
        settingFormData,
        setSettingFormData,
        formDataChild,
        setFormDataChild,
        isParent,
        setIsParent,
        childId,
        setChildId,
        navMapId,
        setNavMapId,
        backImageToggle,
        setBackImageToggle,
        boxSection,
        setBoxSection,
        collId,
        setCollId,
        isBackgroundColor,
        setIsBackgroundColor,
        theme,
        setTheme,
        imageIs,
        setImageIs,
        imgShow,
        setImgShow,
        sectionPageName,
        setSectionPageName,
      }}
    >
      {props.children}
    </OurClientContext.Provider>
  );
};

export default OurClientState;
